import { useState } from 'react'
import CompanyDataForm from './CompanyDataForm'
import OwnerDataForm from './OwnerDataForm'
import PasswordForm from './PasswordForm'
import AddressForm from './AddressForm'
import Confirmation from './Confirmation'
import { FaCheck, FaChevronLeft } from 'react-icons/fa'

import {
  Container,
  StepRow,
  StepContainer,
  StepCircle,
  StepLabel,
  StepLine,
  Circle,
  SmallButton,
  Title,
  InfoText
} from './styles'

export default function CompanySignUp () {
  const steps = [
    {number: 0, label: 'Dados da empresa'},
    {number: 1, label: 'Responsável'},
    {number: 2, label: 'Segurança'},
    {number: 3, label: 'Endereço'},
    {number: 4, label: 'Confirmar'}
  ]

  const [currentStep, setCurrentStep] = useState (steps[0])
  const [companyData, setCompanyData] = useState ({
    logo: null,
    name: '',
    corporate_name: '',
    cnpj: '',
    email: '',
    email_confirmation: '',
    phone: '',
    cellphone: '',
    owner: '',
    owner_email: '',
    owner_phone: '',
    password: '',
    password_confirmation: '',
    address: {
      description: 'Matriz',
      route: '',
      number: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      postal_code: '',
      latitude: 0,
      longitude: 0
    }
  })

  const prevStep = () => setCurrentStep (steps[currentStep.number - 1])
  const nextStep = () => setCurrentStep (steps[currentStep.number + 1])

  const handleFormSubmitted = formData => {
    setCompanyData ({ ...companyData, ...formData })
    nextStep ()
  }

  return (
    <Container>
      <Title>Cadastrar empresa</Title>
      <StepRow>
        {steps.map ((step, index) => (
          <StepContainer key={index}>
            <StepCircle step={step} currentStep={currentStep}>
              {currentStep.number > step.number ? (
                <FaCheck color='#FFFFFF' size={14}/>
              ) : (
                <InfoText>{step.number + 1}</InfoText>
              )}
            </StepCircle>
            <StepLabel>{step.label}</StepLabel>
          </StepContainer>
        ))}
        <StepLine currentStep={currentStep.number}/>
      </StepRow>
      {currentStep.number > 0 && (
        <SmallButton onClick={prevStep}>
          <Circle>
            <FaChevronLeft color='#FFFFFF' size={14} style={{marginLeft: -2}}/>
          </Circle>
          <InfoText style={{ margin: 0, fontWeight: 500 }}>
            Voltar
          </InfoText>
        </SmallButton>
      )}
      {currentStep.number === 0 && (
        <CompanyDataForm companyData={companyData} onFormSubmitted={handleFormSubmitted}/>
      )}
      {currentStep.number === 1 && (
        <OwnerDataForm companyData={companyData} onFormSubmitted={handleFormSubmitted}/>
      )}
      {currentStep.number === 2 && (
        <PasswordForm companyData={companyData} onFormSubmitted={handleFormSubmitted}/>
      )}
      {currentStep.number === 3 && (
        <AddressForm companyData={companyData} onFormSubmitted={handleFormSubmitted}/>
      )}
      {currentStep.number === 4 && (
        <Confirmation companyData={companyData}/>
      )}
    </Container>
  )
}
